import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useMediaQuery from "app/hooks/useMediaQuery";
import OptionNav from "../OptionNav/OptionNav";
import FindBar from "../FindBar/FindBar";
import { animations } from "react-animation";
import * as CMSActions from "./store/actions";
import "./NavBar.css";

function NavBar(props) {
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isMidLaptop = useMediaQuery("(min-width: 1280px)");

  useEffect(() => {
    !contentNavbar && dispatch(CMSActions.getMainNavBar());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { contentNavbar } = useSelector(
    ({ mainNavBar }) => mainNavBar.mainNavbar
  );

  useEffect(() => {
    if (contentNavbar) {
      setOptions(contentNavbar.opciondemenu);
    }
  }, [contentNavbar]);

  //Styles
  const contenedorStyle = () => {
    let cls = "";
    if (is4K) {
      cls = "contenedorBar4K d-flex justify-content-between";
    } else {
      cls = "contenedorBar d-flex justify-content-between";
    }
    return cls;
  };

  const items = (
    <>
      {options.map((option, index) => (
        <OptionNav
          key={index}
          name="csenlinea"
          icon={option.icono.urls[0]}
          title={option.descripcion.html}
          url={option.rutadestino}
        />
      ))}
    </>
  );

  // Navbar component
  const Barra = () => (
    <section
      id="navigationBar"
      name="navigationBar"
      style={{ animation: animations.fadeIn }}
    >
      <nav className="navbar navbar-expand-lg bg-gray">
        <div className={contenedorStyle()}>
          <div className="mt-2">
            <FindBar />
          </div>
          <div className="d-flex justify-content-end">{items}</div>
        </div>
      </nav>
    </section>
  );

  return isMidLaptop && <Barra />;
}

export default NavBar;
